<template>
  <div class="container">
    <div class="row between pb-15 v-c">
      <h4 class="p-0 m-0 mt-20 strong">{{ title }}</h4>
    <span><button 
        class="gray"
        :style="{
            padding: '2px 16px',
            marginTop: '20px'
        }"
        @click="() => this.collapsed = !this.collapsed"
    >
        {{ collapsed ? "+" : "-" }}
    </button></span>
    </div>
    <slot v-if="!collapsed"></slot>
    <hr v-else />
  </div>
</template>

<script>
export default {
  name: "collapsiblecontent",
  data: () => ({ collapsed: false }),
  props: ["title"],
};
</script>